import Section from '@/components/builder/elements/19.estage-internal-embed/Section.js'

export default [
  {
    preview: `<svg width="248" height="140" viewBox="0 0 248 140" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="248" height="140" rx="6" fill="white"/>
<rect x="19" y="42" width="211" height="55" rx="3" stroke="#979797" stroke-width="2"/>
</svg>
`,
    section: {
      'display': true,
      'name': 'Flex Wrapper',
      'hideFromSections': false,
      'component': 'ElFlexWrapperV2',
      'group': '',
      'layout': null,
      'options': {
        'content': {
          'display': true,
          'cols': [{
            'display': true,
            'name': 'Flex Column',
            'elements': [],
            'sortIndex': {'lg': 0, 'md': 0, 'sm': 0},
            'uid': '40iv5RYKWD',
            'sid': 'ibz27y6--bK6jsYgXZy'
          }]
        }
      },
      'uid': '-qrxKasMB',
      'sid': 'ibz27y6--wC_g0H6vXR',
      'temp_id': 'j0pbRmZok',
      'css': [['.--ibz27y6--wC_g0H6vXR--flex { max-width:80vw; --width:80vw; }', '.--ibz27y6--bK6jsYgXZy--flex-col-el { width: 100%; --width: 100%; }'], ['.--ibz27y6--wC_g0H6vXR--flex { max-width: 100%; --width:100%; }'], ['.--ibz27y6--wC_g0H6vXR--flex { max-width: 100%; --width:100%; }']],
      'sids': ['ibz27y6--wC_g0H6vXR', 'ibz27y6--bK6jsYgXZy']
    }
  },
  {
    preview: `<svg width="248" height="140" viewBox="0 0 248 140" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="248" height="140" rx="6" fill="white"/>
<rect x="132" y="42" width="98" height="55" rx="3" stroke="#979797" stroke-width="2"/>
<rect x="19" y="42" width="98" height="55" rx="3" stroke="#979797" stroke-width="2"/>
</svg>
`,
    section: {
      'display': true,
      'name': 'Flex Wrapper',
      'hideFromSections': false,
      'component': 'ElFlexWrapperV2',
      'group': '',
      'layout': null,
      'options': {
        'content': {
          'display': true,
          'cols': [{
            'display': true,
            'name': 'Flex Column',
            'elements': [],
            'sortIndex': {'lg': 0, 'md': 0, 'sm': 0},
            'uid': '40iv5RYKWD',
            'sid': 'lq3mz432--X46B6tWssE',
            'highlight': false
          }, {
            'display': true,
            'name': 'Flex Column',
            'elements': [],
            'sortIndex': {'lg': 1, 'md': 1, 'sm': 1},
            'uid': 'EXGLAjcZm',
            'sid': 'lq3mz432--uJgilpbBHg',
            'highlight': false
          }],
          'animations': {'animation': null, 'once': true, 'offset': 200, 'delay': 50}
        }
      },
      'uid': 'FYxBBC8oU',
      'sid': 'lq3mz432--XHbywUg-8c',
      'temp_id': 'SpR-HP7X_',
      'css': [['.--lq3mz432--X46B6tWssE--flex { max-width:80vw; --width:80vw; }', '.--lq3mz432--X46B6tWssE--flex-col-el { width: 100%; --width: 100%; }', '.--lq3mz432--uJgilpbBHg--flex-col-el { width: 100%; --width: 100%; }', '.--lq3mz432--XHbywUg-8c--flex { max-width: 100%; --width:100%; }'], ['.--lq3mz432--X46B6tWssE--flex { max-width: 100%; --width:100%; }', '.--lq3mz432--XHbywUg-8c--flex { max-width: 100%; --width:100%; flex-wrap: nowrap; }'], ['.--lq3mz432--X46B6tWssE--flex { max-width: 100%; --width:100%; flex-wrap: wrap; }', '.--lq3mz432--XHbywUg-8c--flex { max-width: 100%; --width:100%; flex-wrap: wrap; }']],
      'sids': ['lq3mz432--XHbywUg-8c', 'lq3mz432--X46B6tWssE', 'lq3mz432--uJgilpbBHg']
    }
  },
  {
    preview: `<svg width="248" height="140" viewBox="0 0 248 140" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="248" height="140" rx="6" fill="white"/>
<rect x="171" y="42" width="59" height="55" rx="3" stroke="#979797" stroke-width="2"/>
<rect x="19" y="42" width="59" height="55" rx="3" stroke="#979797" stroke-width="2"/>
<rect x="95" y="42" width="59" height="55" rx="3" stroke="#979797" stroke-width="2"/>
</svg>
`,
    section: {
      'display': true,
      'name': 'Flex Wrapper',
      'hideFromSections': false,
      'component': 'ElFlexWrapperV2',
      'group': '',
      'layout': null,
      'options': {
        'content': {
          'display': true,
          'cols': [{
            'display': true,
            'name': 'Flex Column',
            'elements': [],
            'sortIndex': {'lg': 0, 'md': 0, 'sm': 0},
            'uid': '40iv5RYKWD',
            'sid': 'lq3mz432--8cWnX80ue2',
            'highlight': false
          }, {
            'display': true,
            'name': 'Flex Column',
            'elements': [],
            'sortIndex': {'lg': 1, 'md': 1, 'sm': 1},
            'uid': 'EXGLAjcZm',
            'sid': 'lq3mz432--2xDJ6S_6YK',
            'highlight': false
          }, {
            'display': true,
            'name': 'Flex Column',
            'elements': [],
            'sortIndex': {'lg': 2, 'md': 2, 'sm': 2},
            'uid': '84oui-f0p',
            'sid': 'lq3mz432--XjHsC000sl',
            'highlight': false
          }],
          'animations': {'animation': null, 'once': true, 'offset': 200, 'delay': 50}
        }
      },
      'uid': 'I-ls874z5',
      'sid': 'lq3mz432--kAoHNJYiXZ',
      'temp_id': '-o7_RRf6n',
      'css': [['.--lq3mz432--8cWnX80ue2--flex-col-el { width:100%; --width:100%; }', '.--lq3mz432--2xDJ6S_6YK--flex-col-el { width: 100%; --width: 100%; }', '.--lq3mz432--XjHsC000sl--flex-col-el { width: 100%; --width: 100%; }', '.--lq3mz432--kAoHNJYiXZ--flex { max-width: 80vw; --width:80vw; flex-wrap: nowrap; }'], ['.--lq3mz432--kAoHNJYiXZ--flex { max-width: 100%; --width:100%; flex-wrap: nowrap; }'], ['.--lq3mz432--kAoHNJYiXZ--flex { max-width: 100%; --width:100%; flex-wrap: wrap; }']],
      'sids': ['lq3mz432--kAoHNJYiXZ', 'lq3mz432--8cWnX80ue2', 'lq3mz432--2xDJ6S_6YK', 'lq3mz432--XjHsC000sl']
    }
  },
  {
    preview: `<svg width="248" height="140" viewBox="0 0 248 140" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="248" height="140" rx="6" fill="white"/>
<rect x="29" y="42" width="38" height="55" rx="3" stroke="#979797" stroke-width="2"/>
<rect x="80" y="42" width="38" height="55" rx="3" stroke="#979797" stroke-width="2"/>
<rect x="131" y="42" width="38" height="55" rx="3" stroke="#979797" stroke-width="2"/>
<rect x="182" y="42" width="38" height="55" rx="3" stroke="#979797" stroke-width="2"/>
</svg>
`,
    section: {
      'display': true,
      'name': 'Flex Wrapper',
      'hideFromSections': false,
      'component': 'ElFlexWrapperV2',
      'group': '',
      'layout': null,
      'options': {
        'content': {
          'display': true,
          'cols': [{
            'display': true,
            'name': 'Flex Column',
            'elements': [],
            'sortIndex': {'lg': 0, 'md': 0, 'sm': 0},
            'uid': '40iv5RYKWD',
            'sid': 'lq3mz432--PaYaHjWjvM',
            'highlight': false
          }, {
            'display': true,
            'name': 'Flex Column',
            'elements': [],
            'sortIndex': {'lg': 1, 'md': 1, 'sm': 1},
            'uid': 'EXGLAjcZm',
            'sid': 'lq3mz432--QF4V4xnHId',
            'highlight': false
          }, {
            'display': true,
            'name': 'Flex Column',
            'elements': [],
            'sortIndex': {'lg': 2, 'md': 2, 'sm': 2},
            'uid': '84oui-f0p',
            'sid': 'lq3mz432--z7O-MpwePb',
            'highlight': false
          }, {
            'display': true,
            'name': 'Flex Column',
            'elements': [],
            'sortIndex': {'lg': 3, 'md': 3, 'sm': 3},
            'uid': 'BjiyX2Wzp',
            'sid': 'lq3mz432--3nmUyeHhvC',
            'highlight': false
          }],
          'animations': {'animation': null, 'once': true, 'offset': 200, 'delay': 50}
        }
      },
      'uid': 'Pcu1zZI07',
      'sid': 'lq3mz432--q0M614OWqu',
      'temp_id': 'YQ479Gjit',
      'css': [['.--lq3mz432--PaYaHjWjvM--flex-col-el { width:100%; --width:100%; }', '.--lq3mz432--QF4V4xnHId--flex-col-el { width: 100%; --width: 100%; }', '.--lq3mz432--z7O-MpwePb--flex-col-el { width: 100%; --width: 100%; }', '.--lq3mz432--3nmUyeHhvC--flex-col-el { width: 100%; --width: 100%; }', '.--lq3mz432--q0M614OWqu--flex { max-width: 80vw; --width:80vw; flex-wrap: nowrap; }'], ['.--lq3mz432--q0M614OWqu--flex { max-width: 100%; --width:100%; }'], ['.--lq3mz432--q0M614OWqu--flex { max-width: 100%; --width:100%; flex-wrap: wrap; }']],
      'sids': ['lq3mz432--q0M614OWqu', 'lq3mz432--PaYaHjWjvM', 'lq3mz432--QF4V4xnHId', 'lq3mz432--z7O-MpwePb', 'lq3mz432--3nmUyeHhvC']
    }
  },
  {
    preview: `<svg width="248" height="140" viewBox="0 0 248 140" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="248" height="140" rx="6" fill="white"/>
<rect x="80" y="42" width="150" height="55" rx="3" stroke="#979797" stroke-width="2"/>
<rect x="19" y="42" width="45" height="55" rx="3" stroke="#979797" stroke-width="2"/>
</svg>
`,
    section: {
      'display': true,
      'name': 'Flex Wrapper',
      'hideFromSections': false,
      'component': 'ElFlexWrapperV2',
      'group': '',
      'layout': null,
      'options': {
        'content': {
          'display': true,
          'cols': [{
            'display': true,
            'name': 'Flex Column',
            'elements': [],
            'sortIndex': {'lg': 0, 'md': 0, 'sm': 0},
            'uid': 'y9-HKCrd_',
            'sid': 'lq3mz432--nYLB0-AIhR',
            'highlight': false
          }, {
            'display': true,
            'name': 'Flex Column',
            'elements': [],
            'sortIndex': {'lg': 1, 'md': 1, 'sm': 1},
            'uid': 'Gv7MF_M8dc',
            'sid': 'lq3mz432--c563XxxgL4',
            'highlight': false
          }],
          'animations': {'animation': null, 'once': true, 'offset': 200, 'delay': 50}
        }
      },
      'uid': 'lKRh5Y-GC',
      'sid': 'lq3mz432--qBgNzv4phh',
      'temp_id': '8Xu6_jKV7',
      'css': [['.--lq3mz432--nYLB0-AIhR--flex { max-width:80vw; --width:80vw; }', '.--lq3mz432--nYLB0-AIhR--flex-col-el { width: 30%; }', '.--lq3mz432--c563XxxgL4--flex-col-el { width: 100%; --width: 100%; }', '.--lq3mz432--qBgNzv4phh--flex { flex-wrap: nowrap; max-width: 100%; --width:100%; }'], ['.--lq3mz432--qBgNzv4phh--flex { max-width: 100%; --width:100%; }'], ['.--lq3mz432--qBgNzv4phh--flex { flex-wrap: wrap; width: 100%; --width:100%; }', '.--lq3mz432--nYLB0-AIhR--flex-col-el { width: 100%; --width: 100%; }']],
      'sids': ['lq3mz432--qBgNzv4phh', 'lq3mz432--nYLB0-AIhR', 'lq3mz432--c563XxxgL4']
    }
  },
  {
    preview: `<svg width="248" height="140" viewBox="0 0 248 140" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="248" y="140" width="248" height="140" rx="6" transform="rotate(-180 248 140)" fill="white"/>
<rect x="168" y="98" width="150" height="55" rx="3" transform="rotate(-180 168 98)" stroke="#979797" stroke-width="2"/>
<rect x="229" y="98" width="45" height="55" rx="3" transform="rotate(-180 229 98)" stroke="#979797" stroke-width="2"/>
</svg>
`,
    section: {
      'display': true,
      'name': 'Flex Wrapper',
      'hideFromSections': false,
      'component': 'ElFlexWrapperV2',
      'group': '',
      'layout': null,
      'options': {
        'content': {
          'display': true,
          'cols': [{
            'display': true,
            'name': 'Flex Column',
            'elements': [],
            'sortIndex': {'lg': 0, 'md': 0, 'sm': 0},
            'uid': 'ofNgdnhom',
            'sid': 'lq3mz432--jh16m6fOh7',
            'highlight': false
          }, {
            'display': true,
            'name': 'Flex Column',
            'elements': [],
            'sortIndex': {'lg': 1, 'md': 1, 'sm': 1},
            'uid': 'WzaGv9fe5p',
            'sid': 'lq3mz432--YzBQzDaljo',
            'highlight': false
          }],
          'animations': {'animation': null, 'once': true, 'offset': 200, 'delay': 50}
        }
      },
      'uid': '2mmEyPJYx',
      'sid': 'lq3mz432--DH_eXqDdBR',
      'temp_id': '4_PhNzPk4',
      'css': [['.--lq3mz432--jh16m6fOh7--flex { max-width:80vw; --width:80vw; }', '.--lq3mz432--jh16m6fOh7--flex-col-el { width: 100%; --width: 100%; }', '.--lq3mz432--YzBQzDaljo--flex-col-el { width: 30%; }', '.--lq3mz432--DH_eXqDdBR--flex { flex-wrap: nowrap; max-width: 100%; --width:100%; }'], ['.--lq3mz432--DH_eXqDdBR--flex { max-width: 100%; --width:100%; }'], ['.--lq3mz432--DH_eXqDdBR--flex { flex-wrap: wrap; max-width: 100%; --width:100%; }', '.--lq3mz432--YzBQzDaljo--flex-col-el { width: 100%; --width: 100%; }']],
      'sids': ['lq3mz432--DH_eXqDdBR', 'lq3mz432--jh16m6fOh7', 'lq3mz432--YzBQzDaljo']
    }
  },
  {
    preview: `<svg width="248" height="140" viewBox="0 0 248 140" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="248" height="140" rx="6" fill="white"/>
<rect x="122" y="42" width="108" height="55" rx="3" stroke="#979797" stroke-width="2"/>
<rect x="19" y="42" width="35" height="55" rx="3" stroke="#979797" stroke-width="2"/>
<rect x="70" y="42" width="35" height="55" rx="3" stroke="#979797" stroke-width="2"/>
</svg>
`,
    section: {
      'display': true,
      'name': 'Flex Wrapper',
      'hideFromSections': false,
      'component': 'ElFlexWrapperV2',
      'group': '',
      'layout': null,
      'options': {
        'content': {
          'display': true,
          'cols': [{
            'display': true,
            'name': 'Flex Column',
            'elements': [],
            'sortIndex': {'lg': 0, 'md': 0, 'sm': 0},
            'uid': 'PxTJzszz1',
            'sid': 'lq3mz432--mpbLvRnsAl',
            'highlight': false
          }, {
            'display': true,
            'name': 'Flex Column',
            'elements': [],
            'sortIndex': {'lg': 1, 'md': 1, 'sm': 1},
            'uid': 'iw8J8UegS',
            'sid': 'lq3mz432--mpbLvRnsAl',
            'highlight': false
          }, {
            'display': true,
            'name': 'Flex Column',
            'elements': [],
            'sortIndex': {'lg': 2, 'md': 2, 'sm': 2},
            'uid': 'UVKiQRqP_F',
            'sid': 'lq3mz432--ck2u0CIlpc',
            'highlight': false
          }],
          'animations': {'animation': null, 'once': true, 'offset': 200, 'delay': 50}
        }
      },
      'uid': 'u0gFMBFKS',
      'sid': 'lq3mz432--_BQL4VPvUO',
      'temp_id': 'Q74csLlGQ',
      'css': [['.--lq3mz432--mpbLvRnsAl--flex { max-width:80vw; --width:80vw; }', '.--lq3mz432--mpbLvRnsAl--flex-col-el { width: 30%; }', '.--lq3mz432--_BQL4VPvUO--flex { flex-wrap: nowrap; max-width: 100%; --width:100%; }', '.--lq3mz432--ck2u0CIlpc--flex-col-el { width: 100%; --width: 100%; }'], ['.--lq3mz432--_BQL4VPvUO--flex { max-width: 100%; --width:80vw; flex-wrap: nowrap; }'], ['.--lq3mz432--_BQL4VPvUO--flex { flex-wrap: wrap; max-width: 100%; --width:100%; }', '.--lq3mz432--mpbLvRnsAl--flex-col-el { width: 100%; --width: 100%; }']],
      'sids': ['lq3mz432--_BQL4VPvUO', 'lq3mz432--mpbLvRnsAl', 'lq3mz432--ck2u0CIlpc']
    }
  },
  {
    preview: `<svg width="248" height="140" viewBox="0 0 248 140" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="248" y="140" width="248" height="140" rx="6" transform="rotate(180 248 140)" fill="white"/>
<rect x="126" y="98" width="108" height="55" rx="3" transform="rotate(180 126 98)" stroke="#979797" stroke-width="2"/>
<rect x="229" y="98" width="35" height="55" rx="3" transform="rotate(180 229 98)" stroke="#979797" stroke-width="2"/>
<rect x="178" y="98" width="35" height="55" rx="3" transform="rotate(180 178 98)" stroke="#979797" stroke-width="2"/>
</svg>
`,
    section: {
      'display': true,
      'name': 'Flex Wrapper',
      'hideFromSections': false,
      'component': 'ElFlexWrapperV2',
      'group': '',
      'layout': null,
      'options': {
        'content': {
          'display': true,
          'cols': [{
            'display': true,
            'name': 'Flex Column',
            'elements': [],
            'sortIndex': {'lg': 0, 'md': 0, 'sm': 0},
            'uid': 'CGiY62Rwt',
            'sid': 'lq3mz432--YILYoodJPV',
            'highlight': false
          }, {
            'display': true,
            'name': 'Flex Column',
            'elements': [],
            'sortIndex': {'lg': 1, 'md': 1, 'sm': 1},
            'uid': 'To3WU23B6B',
            'sid': 'lq3mz432--kbKXY_gT76',
            'highlight': false
          }, {
            'display': true,
            'name': 'Flex Column',
            'elements': [],
            'sortIndex': {'lg': 2, 'md': 2, 'sm': 2},
            'uid': 'KrU5uvCJL',
            'sid': 'lq3mz432--XYrh9Scw-F',
            'highlight': false
          }],
          'animations': {'animation': null, 'once': true, 'offset': 200, 'delay': 50}
        }
      },
      'uid': '3ULDdiMFZ',
      'sid': 'lq3mz432--U0lY1iJW9j',
      'temp_id': 'hRAUV6Mwb',
      'css': [['.--lq3mz432--YILYoodJPV--flex { max-width:80vw; --width:80vw; }', '.--lq3mz432--YILYoodJPV--flex-col-el { width: 100%; --width: 100%; }', '.--lq3mz432--kbKXY_gT76--flex-col-el { width: 30%; }', '.--lq3mz432--U0lY1iJW9j--flex { flex-wrap: nowrap; max-width: 80vw; --width:80vw; }', '.--lq3mz432--XYrh9Scw-F--flex-col-el { width: 30%; }'], ['.--lq3mz432--U0lY1iJW9j--flex { max-width: 100%; --width:100%; }'], ['.--lq3mz432--U0lY1iJW9j--flex { flex-wrap: wrap; width: 100%; --width:100%; }', '.--lq3mz432--kbKXY_gT76--flex-col-el { width: 100%; --width: 100%; }', '.--lq3mz432--XYrh9Scw-F--flex-col-el { width: 100%; --width: 100%; }']],
      'sids': ['lq3mz432--U0lY1iJW9j', 'lq3mz432--YILYoodJPV', 'lq3mz432--kbKXY_gT76', 'lq3mz432--XYrh9Scw-F']
    }
  },
  {
    preview: `<svg width="248" height="140" viewBox="0 0 248 140" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="248" y="140" width="248" height="140" rx="6" transform="rotate(180 248 140)" fill="white"/>
<rect x="178" y="98" width="108" height="55" rx="3" transform="rotate(180 178 98)" stroke="#979797" stroke-width="2"/>
<rect x="230" y="98" width="35" height="55" rx="3" transform="rotate(180 230 98)" stroke="#979797" stroke-width="2"/>
<rect x="53" y="98" width="35" height="55" rx="3" transform="rotate(180 53 98)" stroke="#979797" stroke-width="2"/>
</svg>
`,
    section: {
      'display': true,
      'name': 'Flex Wrapper',
      'hideFromSections': false,
      'component': 'ElFlexWrapperV2',
      'group': '',
      'layout': null,
      'options': {
        'content': {
          'display': true,
          'cols': [{
            'display': true,
            'name': 'Flex Column',
            'elements': [],
            'sortIndex': {'lg': 0, 'md': 0, 'sm': 0},
            'uid': 'r2n5CDUmD',
            'sid': 'lq3mz432--DLtTIIkGla',
            'highlight': false
          }, {
            'display': true,
            'name': 'Flex Column',
            'elements': [],
            'sortIndex': {'lg': 1, 'md': 2, 'sm': 2},
            'uid': 'QJ4khj_XdP',
            'sid': 'lq3mz432--qF5UdMpQtJ',
            'highlight': false
          }, {
            'display': true,
            'name': 'Flex Column',
            'elements': [],
            'sortIndex': {'lg': 2, 'md': 2, 'sm': 2},
            'uid': 'yvzCwxO4I',
            'sid': 'lq3mz432--VpdiqtVVpx',
            'highlight': false
          }],
          'animations': {'animation': null, 'once': true, 'offset': 200, 'delay': 50}
        }
      },
      'uid': 'sp9ufEYB9',
      'sid': 'lq3mz432--ZRHs8EzfTB',
      'temp_id': 'GT2O31nn6',
      'css': [['.--lq3mz432--DLtTIIkGla--flex-col-el { width: 30%; }', '.--lq3mz432--ZRHs8EzfTB--flex { flex-wrap: nowrap; max-width: 80vw; --width:80vw; }', '.--lq3mz432--qF5UdMpQtJ--flex-col-el { width: 100%; --width: 100%; }', '.--lq3mz432--VpdiqtVVpx--flex-col-el { width: 30%; }'], ['.--lq3mz432--ZRHs8EzfTB--flex { max-width: 100%; --width:100%; }'], ['.--lq3mz432--ZRHs8EzfTB--flex { flex-wrap: wrap; max-width: 100%; --width:100%; }', '.--lq3mz432--DLtTIIkGla--flex-col-el { width: 100%; --width: 100%; }', '.--lq3mz432--VpdiqtVVpx--flex-col-el { width: 100%; --width: 100%; }']],
      'sids': ['lq3mz432--ZRHs8EzfTB', 'lq3mz432--DLtTIIkGla', 'lq3mz432--qF5UdMpQtJ', 'lq3mz432--VpdiqtVVpx']
    }
  },
  {
    preview: '<svg width="248" height="140" viewBox="0 0 248 140" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
      '<rect x="248" y="140" width="248" height="140" rx="6" transform="rotate(180 248 140)" fill="white"/>\n' +
      '<rect x="231" y="64" width="42" height="32" rx="3" transform="rotate(180 231 64)" stroke="#979797" stroke-width="2"/>\n' +
      '<rect x="60" y="64" width="42" height="32" rx="3" transform="rotate(180 60 64)" stroke="#979797" stroke-width="2"/>\n' +
      '<rect x="117" y="64" width="42" height="32" rx="3" transform="rotate(180 117 64)" stroke="#979797" stroke-width="2"/>\n' +
      '<rect x="174" y="64" width="42" height="32" rx="3" transform="rotate(180 174 64)" stroke="#979797" stroke-width="2"/>\n' +
      '<rect x="231" y="107" width="42" height="32" rx="3" transform="rotate(180 231 107)" stroke="#979797" stroke-width="2"/>\n' +
      '<rect x="60" y="107" width="42" height="32" rx="3" transform="rotate(180 60 107)" stroke="#979797" stroke-width="2"/>\n' +
      '<rect x="117" y="107" width="42" height="32" rx="3" transform="rotate(180 117 107)" stroke="#979797" stroke-width="2"/>\n' +
      '<rect x="174" y="107" width="42" height="32" rx="3" transform="rotate(180 174 107)" stroke="#979797" stroke-width="2"/>\n' +
      '</svg>',
    section: {
      'display': true,
      'name': 'Flex Wrapper',
      'hideFromSections': false,
      'component': 'ElFlexWrapperV2',
      'group': '',
      'layout': null,
      'options': {
        'content': {
          'display': true,
          'cols': [{
            'display': true,
            'name': 'Flex Column',
            'elements': [],
            'sortIndex': {'lg': 0, 'md': 0, 'sm': 0},
            'uid': 'IfLEYElrW',
            'sid': 'lq3mz432--lJBQzq7Du3',
            'highlight': false
          }, {
            'display': true,
            'name': 'Flex Column',
            'elements': [],
            'sortIndex': {'lg': 1, 'md': 1, 'sm': 1},
            'uid': 'W9j8FL7DL',
            'sid': 'lq3mz432--2Z69slogyu',
            'highlight': false
          }, {
            'display': true,
            'name': 'Flex Column',
            'elements': [],
            'sortIndex': {'lg': 2, 'md': 2, 'sm': 2},
            'uid': 'ERfiPVFxot',
            'sid': 'lq3mz432--QFH6h3f6q2',
            'highlight': false
          }, {
            'display': true,
            'name': 'Flex Column',
            'elements': [],
            'sortIndex': {'lg': 3, 'md': 3, 'sm': 3},
            'uid': 'D_5bpgEH-',
            'sid': 'lq3mz432--O0Cf6uqbjn',
            'highlight': false
          }, {
            'display': true,
            'name': 'Flex Column',
            'elements': [],
            'sortIndex': {'lg': 4, 'md': 4, 'sm': 4},
            'uid': 'Z8eD3aN_M',
            'sid': 'lq3mz432--Vv_PxQ28kl',
            'highlight': false
          }, {
            'display': true,
            'name': 'Flex Column',
            'elements': [],
            'sortIndex': {'lg': 5, 'md': 5, 'sm': 5},
            'uid': 'o8FRoEtIXp',
            'sid': 'lq3mz432--s3Y4OOGLar',
            'highlight': false
          }, {
            'display': true,
            'name': 'Flex Column',
            'elements': [],
            'sortIndex': {'lg': 6, 'md': 6, 'sm': 6},
            'uid': '65JElQyQWg',
            'sid': 'lq3mz432--HctBmQfLmL',
            'highlight': false
          }, {
            'display': true,
            'name': 'Flex Column',
            'elements': [],
            'sortIndex': {'lg': 7, 'md': 7, 'sm': 7},
            'uid': '8T4sD424h',
            'sid': 'lq3mz432--FaU2fU7AQ6',
            'highlight': false
          }],
          'animations': {'animation': null, 'once': true, 'offset': 200, 'delay': 50}
        }
      },
      'uid': 'HAs9pCfVO',
      'sid': 'lq3mz432--gpRE6tWmKY',
      'temp_id': 'Q8e4-e1ws',
      'css': [['.--lq3mz432--gpRE6tWmKY--flex { max-width: 100%; --width:100%; flex-wrap: wrap; }', '.--lq3mz432--FaU2fU7AQ6--flex-col-el { width: 25%; --width: 25%; }', '.--lq3mz432--lJBQzq7Du3--flex-col-el { width: 25%; --width: 25%; }', '.--lq3mz432--2Z69slogyu--flex-col-el { width: 25%; --width: 25%; }', '.--lq3mz432--QFH6h3f6q2--flex-col-el { width: 25%; --width: 25%; }', '.--lq3mz432--O0Cf6uqbjn--flex-col-el { width: 25%; --width: 25%; }', '.--lq3mz432--Vv_PxQ28kl--flex-col-el { width: 25%; --width: 25%; }', '.--lq3mz432--s3Y4OOGLar--flex-col-el { width: 25%; --width: 25%; }', '.--lq3mz432--HctBmQfLmL--flex-col-el { width: 25%; --width: 25%; }'], ['.--lq3mz432--FaU2fU7AQ6--flex-col-el { width: 50%; }', '.--lq3mz432--lJBQzq7Du3--flex-col-el { width: 50%; }', '.--lq3mz432--2Z69slogyu--flex-col-el { width: 50%; }', '.--lq3mz432--QFH6h3f6q2--flex-col-el { width: 50%; }', '.--lq3mz432--O0Cf6uqbjn--flex-col-el { width: 50%; }', '.--lq3mz432--Vv_PxQ28kl--flex-col-el { width: 50%; }', '.--lq3mz432--s3Y4OOGLar--flex-col-el { width: 50%; }', '.--lq3mz432--HctBmQfLmL--flex-col-el { width: 50%; }', '.--lq3mz432--gpRE6tWmKY--flex { max-width: 100%; --width:100%; }'], ['.--lq3mz432--gpRE6tWmKY--flex { flex-wrap: wrap; width: 100%; --width:100%; }', '.--lq3mz432--lJBQzq7Du3--flex-col-el { width: 100%; --width: 100%; }', '.--lq3mz432--2Z69slogyu--flex-col-el { width: 100%; --width: 100%; }', '.--lq3mz432--QFH6h3f6q2--flex-col-el { width: 100%; --width: 100%; }', '.--lq3mz432--O0Cf6uqbjn--flex-col-el { width: 100%; --width: 100%; }', '.--lq3mz432--Vv_PxQ28kl--flex-col-el { width: 100%; --width: 100%; }', '.--lq3mz432--s3Y4OOGLar--flex-col-el { width: 100%; --width: 100%; }', '.--lq3mz432--HctBmQfLmL--flex-col-el { width: 100%; --width: 100%; }', '.--lq3mz432--FaU2fU7AQ6--flex-col-el { width: 100%; --width: 100%; }']],
      'sids': ['lq3mz432--gpRE6tWmKY', 'lq3mz432--lJBQzq7Du3', 'lq3mz432--2Z69slogyu', 'lq3mz432--QFH6h3f6q2', 'lq3mz432--O0Cf6uqbjn', 'lq3mz432--Vv_PxQ28kl', 'lq3mz432--s3Y4OOGLar', 'lq3mz432--HctBmQfLmL', 'lq3mz432--FaU2fU7AQ6']
    }
  },
  {
    section: new Section().json(),
    preview: `<svg width="248" height="140" viewBox="0 0 248 140" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M6 140L242 140C245.314 140 248 137.314 248 134L248 6C248 2.68629 245.314 0 242 0L6 0C2.68629 0 0 2.68629 0 6L0 134C0 137.314 2.68629 140 6 140Z" fill="white"/>
<path d="M17.4091 75V63.3636H24.4318V64.6136H18.8182V68.5455H24.0682V69.7955H18.8182V73.75H24.5227V75H17.4091ZM33.3352 66.2727C33.267 65.697 32.9905 65.25 32.5057 64.9318C32.0208 64.6136 31.4261 64.4545 30.7216 64.4545C30.2064 64.4545 29.7557 64.5379 29.3693 64.7045C28.9867 64.8712 28.6875 65.1004 28.4716 65.392C28.2595 65.6837 28.1534 66.0152 28.1534 66.3864C28.1534 66.697 28.2273 66.964 28.375 67.1875C28.5265 67.4072 28.7197 67.5909 28.9545 67.7386C29.1894 67.8826 29.4356 68.0019 29.6932 68.0966C29.9508 68.1875 30.1875 68.2614 30.4034 68.3182L31.5852 68.6364C31.8883 68.7159 32.2254 68.8258 32.5966 68.9659C32.9716 69.1061 33.3295 69.2973 33.6705 69.5398C34.0152 69.7784 34.2992 70.0852 34.5227 70.4602C34.7462 70.8352 34.858 71.2955 34.858 71.8409C34.858 72.4697 34.6932 73.0379 34.3636 73.5455C34.0379 74.053 33.5606 74.4564 32.9318 74.7557C32.3068 75.0549 31.5473 75.2045 30.6534 75.2045C29.8201 75.2045 29.0985 75.0701 28.4886 74.8011C27.8826 74.5322 27.4053 74.1572 27.0568 73.6761C26.7121 73.1951 26.517 72.6364 26.4716 72H27.9261C27.964 72.4394 28.1117 72.803 28.3693 73.0909C28.6307 73.375 28.9602 73.5871 29.358 73.7273C29.7595 73.8636 30.1913 73.9318 30.6534 73.9318C31.1913 73.9318 31.6742 73.8447 32.1023 73.6705C32.5303 73.4924 32.8693 73.2462 33.1193 72.9318C33.3693 72.6136 33.4943 72.2424 33.4943 71.8182C33.4943 71.4318 33.3864 71.1174 33.1705 70.875C32.9545 70.6326 32.6705 70.4356 32.3182 70.2841C31.9659 70.1326 31.5852 70 31.1761 69.8864L29.7443 69.4773C28.8352 69.2159 28.1155 68.8428 27.5852 68.358C27.0549 67.8731 26.7898 67.2386 26.7898 66.4545C26.7898 65.803 26.9659 65.2348 27.3182 64.75C27.6742 64.2614 28.1515 63.8826 28.75 63.6136C29.3523 63.3409 30.0246 63.2045 30.767 63.2045C31.517 63.2045 32.1837 63.339 32.767 63.608C33.3504 63.8731 33.8125 64.2367 34.1534 64.6989C34.4981 65.161 34.6799 65.6856 34.6989 66.2727H33.3352ZM36.5384 64.6136V63.3636H45.2656V64.6136H41.6065V75H40.1974V64.6136H36.5384ZM46.5582 75H45.081L49.3537 63.3636H50.8082L55.081 75H53.6037L50.1264 65.2045H50.0355L46.5582 75ZM47.1037 70.4545H53.0582V71.7045H47.1037V70.4545ZM64.3011 67C64.1761 66.6174 64.0114 66.2746 63.8068 65.9716C63.6061 65.6648 63.3655 65.4034 63.0852 65.1875C62.8087 64.9716 62.4943 64.8068 62.142 64.6932C61.7898 64.5795 61.4034 64.5227 60.983 64.5227C60.2936 64.5227 59.6667 64.7008 59.1023 65.0568C58.5379 65.4129 58.089 65.9375 57.7557 66.6307C57.4223 67.3239 57.2557 68.1742 57.2557 69.1818C57.2557 70.1894 57.4242 71.0398 57.7614 71.733C58.0985 72.4261 58.5549 72.9508 59.1307 73.3068C59.7064 73.6629 60.3542 73.8409 61.0739 73.8409C61.7405 73.8409 62.3277 73.6989 62.8352 73.4148C63.3466 73.1269 63.7443 72.7216 64.0284 72.1989C64.3163 71.6723 64.4602 71.053 64.4602 70.3409L64.892 70.4318H61.392V69.1818H65.8239V70.4318C65.8239 71.3902 65.6193 72.2235 65.2102 72.9318C64.8049 73.6402 64.2443 74.1894 63.5284 74.5795C62.8163 74.9659 61.9981 75.1591 61.0739 75.1591C60.0436 75.1591 59.1383 74.9167 58.358 74.4318C57.5814 73.947 56.9754 73.2576 56.5398 72.3636C56.108 71.4697 55.892 70.4091 55.892 69.1818C55.892 68.2614 56.0152 67.4337 56.2614 66.6989C56.5114 65.9602 56.8636 65.3314 57.3182 64.8125C57.7727 64.2936 58.3106 63.8958 58.9318 63.6193C59.553 63.3428 60.2367 63.2045 60.983 63.2045C61.5966 63.2045 62.1686 63.2973 62.6989 63.483C63.233 63.6648 63.7083 63.9242 64.125 64.2614C64.5455 64.5947 64.8958 64.9943 65.1761 65.4602C65.4564 65.9223 65.6496 66.4356 65.7557 67H64.3011ZM68.2372 75V63.3636H75.2599V64.6136H69.6463V68.5455H74.8963V69.7955H69.6463V73.75H75.3509V75H68.2372ZM83.7088 63.3636V75H82.2997V63.3636H83.7088ZM87.6932 69.75V75H86.3523V66.2727H87.6477V67.6364H87.7614C87.9659 67.1932 88.2765 66.8371 88.6932 66.5682C89.1098 66.2955 89.6477 66.1591 90.3068 66.1591C90.8977 66.1591 91.4148 66.2803 91.858 66.5227C92.3011 66.7614 92.6458 67.125 92.892 67.6136C93.1383 68.0985 93.2614 68.7121 93.2614 69.4545V75H91.9205V69.5455C91.9205 68.8598 91.7424 68.3258 91.3864 67.9432C91.0303 67.5568 90.5417 67.3636 89.9205 67.3636C89.4924 67.3636 89.1098 67.4564 88.7727 67.642C88.4394 67.8277 88.1761 68.0985 87.983 68.4545C87.7898 68.8106 87.6932 69.2424 87.6932 69.75ZM99.5071 66.2727V67.4091H94.9844V66.2727H99.5071ZM96.3026 64.1818H97.6435V72.5C97.6435 72.8788 97.6984 73.1629 97.8082 73.3523C97.9219 73.5379 98.0658 73.6629 98.2401 73.7273C98.4181 73.7879 98.6056 73.8182 98.8026 73.8182C98.9503 73.8182 99.0715 73.8106 99.1662 73.7955C99.2609 73.7765 99.3366 73.7614 99.3935 73.75L99.6662 74.9545C99.5753 74.9886 99.4484 75.0227 99.2855 75.0568C99.1226 75.0947 98.9162 75.1136 98.6662 75.1136C98.2874 75.1136 97.9162 75.0322 97.5526 74.8693C97.1927 74.7064 96.8935 74.4583 96.6548 74.125C96.42 73.7917 96.3026 73.3712 96.3026 72.8636V64.1818ZM105.089 75.1818C104.249 75.1818 103.523 74.9962 102.913 74.625C102.307 74.25 101.839 73.7273 101.51 73.0568C101.184 72.3826 101.021 71.5985 101.021 70.7045C101.021 69.8106 101.184 69.0227 101.51 68.3409C101.839 67.6553 102.298 67.1212 102.885 66.7386C103.476 66.3523 104.165 66.1591 104.953 66.1591C105.408 66.1591 105.857 66.2348 106.3 66.3864C106.743 66.5379 107.146 66.7841 107.51 67.125C107.874 67.4621 108.163 67.9091 108.379 68.4659C108.595 69.0227 108.703 69.7083 108.703 70.5227V71.0909H101.976V69.9318H107.339C107.339 69.4394 107.241 69 107.044 68.6136C106.851 68.2273 106.574 67.9223 106.214 67.6989C105.858 67.4754 105.438 67.3636 104.953 67.3636C104.419 67.3636 103.957 67.4962 103.567 67.7614C103.18 68.0227 102.883 68.3636 102.675 68.7841C102.466 69.2045 102.362 69.6553 102.362 70.1364V70.9091C102.362 71.5682 102.476 72.1269 102.703 72.5852C102.934 73.0398 103.254 73.3864 103.663 73.625C104.072 73.8598 104.548 73.9773 105.089 73.9773C105.442 73.9773 105.76 73.928 106.044 73.8295C106.332 73.7273 106.58 73.5758 106.788 73.375C106.997 73.1705 107.158 72.9167 107.271 72.6136L108.567 72.9773C108.43 73.4167 108.201 73.803 107.879 74.1364C107.557 74.4659 107.16 74.7235 106.686 74.9091C106.213 75.0909 105.68 75.1818 105.089 75.1818ZM110.743 75V66.2727H112.038V67.5909H112.129C112.288 67.1591 112.576 66.8087 112.993 66.5398C113.41 66.2708 113.879 66.1364 114.402 66.1364C114.5 66.1364 114.624 66.1383 114.771 66.142C114.919 66.1458 115.031 66.1515 115.107 66.1591V67.5227C115.061 67.5114 114.957 67.4943 114.794 67.4716C114.635 67.4451 114.466 67.4318 114.288 67.4318C113.864 67.4318 113.485 67.5208 113.152 67.6989C112.822 67.8731 112.561 68.1155 112.368 68.4261C112.179 68.733 112.084 69.0833 112.084 69.4773V75H110.743ZM118.037 69.75V75H116.696V66.2727H117.991V67.6364H118.105C118.31 67.1932 118.62 66.8371 119.037 66.5682C119.454 66.2955 119.991 66.1591 120.651 66.1591C121.241 66.1591 121.759 66.2803 122.202 66.5227C122.645 66.7614 122.99 67.125 123.236 67.6136C123.482 68.0985 123.605 68.7121 123.605 69.4545V75H122.264V69.5455C122.264 68.8598 122.086 68.3258 121.73 67.9432C121.374 67.5568 120.885 67.3636 120.264 67.3636C119.836 67.3636 119.454 67.4564 119.116 67.642C118.783 67.8277 118.52 68.0985 118.327 68.4545C118.134 68.8106 118.037 69.2424 118.037 69.75ZM128.624 75.2045C128.071 75.2045 127.569 75.1004 127.118 74.892C126.667 74.6799 126.309 74.375 126.044 73.9773C125.779 73.5758 125.646 73.0909 125.646 72.5227C125.646 72.0227 125.745 71.6174 125.942 71.3068C126.139 70.9924 126.402 70.7462 126.732 70.5682C127.061 70.3902 127.425 70.2576 127.822 70.1705C128.224 70.0795 128.627 70.0076 129.033 69.9545C129.563 69.8864 129.993 69.8352 130.322 69.8011C130.656 69.7633 130.898 69.7008 131.05 69.6136C131.205 69.5265 131.283 69.375 131.283 69.1591V69.1136C131.283 68.553 131.129 68.1174 130.822 67.8068C130.519 67.4962 130.059 67.3409 129.442 67.3409C128.802 67.3409 128.3 67.4811 127.936 67.7614C127.572 68.0417 127.317 68.3409 127.169 68.6591L125.896 68.2045C126.124 67.6742 126.427 67.2614 126.805 66.9659C127.188 66.6667 127.605 66.4583 128.055 66.3409C128.51 66.2197 128.957 66.1591 129.396 66.1591C129.677 66.1591 129.999 66.1932 130.362 66.2614C130.73 66.3258 131.084 66.4602 131.425 66.6648C131.769 66.8693 132.055 67.178 132.283 67.5909C132.51 68.0038 132.624 68.5568 132.624 69.25V75H131.283V73.8182H131.214C131.124 74.0076 130.972 74.2102 130.76 74.4261C130.548 74.642 130.266 74.8258 129.913 74.9773C129.561 75.1288 129.131 75.2045 128.624 75.2045ZM128.828 74C129.358 74 129.805 73.8958 130.169 73.6875C130.536 73.4792 130.813 73.2102 130.999 72.8807C131.188 72.5511 131.283 72.2045 131.283 71.8409V70.6136C131.226 70.6818 131.101 70.7443 130.908 70.8011C130.718 70.8542 130.499 70.9015 130.249 70.9432C130.002 70.9811 129.762 71.0152 129.527 71.0455C129.296 71.072 129.108 71.0947 128.964 71.1136C128.616 71.1591 128.29 71.233 127.987 71.3352C127.688 71.4337 127.446 71.5833 127.26 71.7841C127.078 71.9811 126.987 72.25 126.987 72.5909C126.987 73.0568 127.16 73.4091 127.504 73.6477C127.853 73.8826 128.294 74 128.828 74ZM136.412 63.3636V75H135.071V63.3636H136.412ZM143.55 75V63.3636H150.572V64.6136H144.959V68.5455H150.209V69.7955H144.959V73.75H150.663V75H143.55ZM152.93 75V66.2727H154.226V67.6364H154.339C154.521 67.1705 154.815 66.8087 155.22 66.5511C155.625 66.2898 156.112 66.1591 156.68 66.1591C157.256 66.1591 157.735 66.2898 158.118 66.5511C158.504 66.8087 158.805 67.1705 159.021 67.6364H159.112C159.336 67.1856 159.671 66.8277 160.118 66.5625C160.565 66.2936 161.101 66.1591 161.726 66.1591C162.506 66.1591 163.144 66.4034 163.641 66.892C164.137 67.3769 164.385 68.1326 164.385 69.1591V75H163.044V69.1591C163.044 68.5152 162.868 68.0549 162.516 67.7784C162.163 67.5019 161.749 67.3636 161.271 67.3636C160.658 67.3636 160.182 67.5492 159.845 67.9205C159.508 68.2879 159.339 68.7538 159.339 69.3182V75H157.976V69.0227C157.976 68.5265 157.815 68.1269 157.493 67.8239C157.171 67.517 156.756 67.3636 156.249 67.3636C155.9 67.3636 155.574 67.4564 155.271 67.642C154.972 67.8277 154.73 68.0852 154.544 68.4148C154.362 68.7405 154.271 69.1174 154.271 69.5455V75H152.93ZM167.018 75V63.3636H168.359V67.6591H168.473C168.571 67.5076 168.708 67.3144 168.882 67.0795C169.06 66.8409 169.314 66.6288 169.643 66.4432C169.977 66.2538 170.428 66.1591 170.996 66.1591C171.731 66.1591 172.378 66.3428 172.939 66.7102C173.5 67.0777 173.937 67.5985 174.251 68.2727C174.566 68.947 174.723 69.7424 174.723 70.6591C174.723 71.5833 174.566 72.3845 174.251 73.0625C173.937 73.7367 173.501 74.2595 172.945 74.6307C172.388 74.9981 171.746 75.1818 171.018 75.1818C170.458 75.1818 170.009 75.089 169.672 74.9034C169.335 74.714 169.075 74.5 168.893 74.2614C168.712 74.0189 168.571 73.8182 168.473 73.6591H168.314V75H167.018ZM168.337 70.6364C168.337 71.2955 168.433 71.8769 168.626 72.3807C168.82 72.8807 169.102 73.2727 169.473 73.5568C169.844 73.8371 170.299 73.9773 170.837 73.9773C171.397 73.9773 171.865 73.8295 172.24 73.5341C172.619 73.2348 172.903 72.8333 173.092 72.3295C173.286 71.822 173.382 71.2576 173.382 70.6364C173.382 70.0227 173.287 69.4697 173.098 68.9773C172.912 68.4811 172.63 68.089 172.251 67.8011C171.876 67.5095 171.405 67.3636 170.837 67.3636C170.291 67.3636 169.833 67.5019 169.462 67.7784C169.09 68.0511 168.81 68.4337 168.621 68.9261C168.431 69.4148 168.337 69.9848 168.337 70.6364ZM180.433 75.1818C179.592 75.1818 178.867 74.9962 178.257 74.625C177.651 74.25 177.183 73.7273 176.854 73.0568C176.528 72.3826 176.365 71.5985 176.365 70.7045C176.365 69.8106 176.528 69.0227 176.854 68.3409C177.183 67.6553 177.642 67.1212 178.229 66.7386C178.82 66.3523 179.509 66.1591 180.297 66.1591C180.751 66.1591 181.2 66.2348 181.643 66.3864C182.087 66.5379 182.49 66.7841 182.854 67.125C183.217 67.4621 183.507 67.9091 183.723 68.4659C183.939 69.0227 184.047 69.7083 184.047 70.5227V71.0909H177.32V69.9318H182.683C182.683 69.4394 182.585 69 182.388 68.6136C182.195 68.2273 181.918 67.9223 181.558 67.6989C181.202 67.4754 180.782 67.3636 180.297 67.3636C179.763 67.3636 179.301 67.4962 178.911 67.7614C178.524 68.0227 178.227 68.3636 178.018 68.7841C177.81 69.2045 177.706 69.6553 177.706 70.1364V70.9091C177.706 71.5682 177.82 72.1269 178.047 72.5852C178.278 73.0398 178.598 73.3864 179.007 73.625C179.416 73.8598 179.892 73.9773 180.433 73.9773C180.786 73.9773 181.104 73.928 181.388 73.8295C181.676 73.7273 181.924 73.5758 182.132 73.375C182.34 73.1705 182.501 72.9167 182.615 72.6136L183.911 72.9773C183.774 73.4167 183.545 73.803 183.223 74.1364C182.901 74.4659 182.503 74.7235 182.03 74.9091C181.556 75.0909 181.024 75.1818 180.433 75.1818ZM189.382 75.1818C188.655 75.1818 188.013 74.9981 187.456 74.6307C186.899 74.2595 186.464 73.7367 186.149 73.0625C185.835 72.3845 185.678 71.5833 185.678 70.6591C185.678 69.7424 185.835 68.947 186.149 68.2727C186.464 67.5985 186.901 67.0777 187.462 66.7102C188.022 66.3428 188.67 66.1591 189.405 66.1591C189.973 66.1591 190.422 66.2538 190.751 66.4432C191.085 66.6288 191.339 66.8409 191.513 67.0795C191.691 67.3144 191.829 67.5076 191.928 67.6591H192.041V63.3636H193.382V75H192.087V73.6591H191.928C191.829 73.8182 191.689 74.0189 191.507 74.2614C191.325 74.5 191.066 74.714 190.729 74.9034C190.392 75.089 189.943 75.1818 189.382 75.1818ZM189.564 73.9773C190.102 73.9773 190.556 73.8371 190.928 73.5568C191.299 73.2727 191.581 72.8807 191.774 72.3807C191.967 71.8769 192.064 71.2955 192.064 70.6364C192.064 69.9848 191.969 69.4148 191.78 68.9261C191.59 68.4337 191.31 68.0511 190.939 67.7784C190.568 67.5019 190.109 67.3636 189.564 67.3636C188.996 67.3636 188.522 67.5095 188.143 67.8011C187.768 68.089 187.486 68.4811 187.297 68.9773C187.111 69.4697 187.018 70.0227 187.018 70.6364C187.018 71.2576 187.113 71.822 187.303 72.3295C187.496 72.8333 187.78 73.2348 188.155 73.5341C188.534 73.8295 189.003 73.9773 189.564 73.9773ZM200.706 75V63.3636H204.638C205.547 63.3636 206.293 63.5189 206.876 63.8295C207.46 64.1364 207.892 64.5587 208.172 65.0966C208.452 65.6345 208.592 66.2462 208.592 66.9318C208.592 67.6174 208.452 68.2254 208.172 68.7557C207.892 69.286 207.462 69.7027 206.882 70.0057C206.303 70.3049 205.562 70.4545 204.661 70.4545H201.479V69.1818H204.615C205.236 69.1818 205.736 69.0909 206.115 68.9091C206.498 68.7273 206.774 68.4697 206.945 68.1364C207.119 67.7992 207.206 67.3977 207.206 66.9318C207.206 66.4659 207.119 66.0587 206.945 65.7102C206.77 65.3617 206.492 65.0928 206.109 64.9034C205.727 64.7102 205.221 64.6136 204.592 64.6136H202.115V75H200.706ZM206.183 69.7727L209.047 75H207.411L204.592 69.7727H206.183ZM214.21 75.1818C213.422 75.1818 212.731 74.9943 212.136 74.6193C211.545 74.2443 211.083 73.7197 210.75 73.0455C210.42 72.3712 210.256 71.5833 210.256 70.6818C210.256 69.7727 210.42 68.9792 210.75 68.3011C211.083 67.6231 211.545 67.0966 212.136 66.7216C212.731 66.3466 213.422 66.1591 214.21 66.1591C214.998 66.1591 215.688 66.3466 216.278 66.7216C216.873 67.0966 217.335 67.6231 217.665 68.3011C217.998 68.9792 218.165 69.7727 218.165 70.6818C218.165 71.5833 217.998 72.3712 217.665 73.0455C217.335 73.7197 216.873 74.2443 216.278 74.6193C215.688 74.9943 214.998 75.1818 214.21 75.1818ZM214.21 73.9773C214.809 73.9773 215.301 73.8239 215.688 73.517C216.074 73.2102 216.36 72.8068 216.545 72.3068C216.731 71.8068 216.824 71.2652 216.824 70.6818C216.824 70.0985 216.731 69.5549 216.545 69.0511C216.36 68.5473 216.074 68.1402 215.688 67.8295C215.301 67.5189 214.809 67.3636 214.21 67.3636C213.612 67.3636 213.119 67.5189 212.733 67.8295C212.347 68.1402 212.061 68.5473 211.875 69.0511C211.689 69.5549 211.597 70.0985 211.597 70.6818C211.597 71.2652 211.689 71.8068 211.875 72.3068C212.061 72.8068 212.347 73.2102 212.733 73.517C213.119 73.8239 213.612 73.9773 214.21 73.9773ZM221.892 75L219.233 66.2727H220.642L222.528 72.9545H222.619L224.483 66.2727H225.915L227.756 72.9318H227.847L229.733 66.2727H231.142L228.483 75H227.165L225.256 68.2955H225.119L223.21 75H221.892Z" fill="#979797"/>
</svg>
`
  }
]